<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-page-heading [ttModel]="'p2_m_counters'" ttTranslate></tt-page-heading>

        <tt-card>
            <form class="form-horizontal sp-0" name="formCountersSearch" novalidate (ngSubmit)="onSearchTextChanged()" method="get" role="form">
                <tt-input ttRememberId="w_counters.searchtext" ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
            </form>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-page-heading [ttModel]="'p2_m_counters'" ttTranslate></tt-page-heading>

        <tt-divider ttRememberId="counters_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card>
                        <form class="form-horizontal sp-0" name="formCountersSearch" novalidate (ngSubmit)="onSearchTextChanged()" method="get" role="form">
                            <tt-input ttRememberId="w_counters.searchtext" ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
                        </form>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
